<div [class.card-icons]="viewCard" *ngIf="!isWishList">
  <div *ngIf="selected" class="tooltip-container">
    <span class="favorite-artifact-selected fa fa-heart"></span>
    <span class="tooltip-text">Added this to your wish list</span>
  </div>
  <div *ngIf="!selected">
    <span class="favorite-artifact fa fa-heart-o"></span>
  </div>
</div>
<div *ngIf="isWishList">
<div *ngIf="selected">
    <span class="favorite-artifact-close fa fa-trash-o"></span>
 </div>
</div>
